function textCleanup(l) {
  if (/^\d/.test(l)) l = l.slice(2)
  if (l.includes(';-')) l = l.slice(0, l.indexOf(';'))
  if (l.includes(')')) l = l.slice(0, l.indexOf(')') + 1)
  l = l.replace(';-', '')
  return l
}

function hasNumLabels(lyrics) {
  return lyrics.some(v => v[0] && /^\d/.test(v[0][0]))
}

function verseLabel(verse, verse2, index, numLabels) {
  if (numLabels) {
    if (verse2[0] && /^\d/.test(verse2[0][0])) return `Verse ${verse2[0][0]}`
    if (!verse[0] || !verse[0].length) return 'Verse 99'
    return 'Chorus'
  }
  return `Verse ${index + 1}`
}

function SongPreview({ song }) {
  if (!song) return null

  const numLabels = hasNumLabels(song.lyrics)

  return (
    <div className="song-preview">
      <div className="song-preview-header">
        <div className="fg-ac1 fs-5 fw-bold">{song.title}</div>
        <div className="fg-l2 fw-lighter fs-6">{song.title2}</div>
      </div>
      <div className="song-preview-lyrics">
        {song.lyrics2 && song.lyrics2.map((verse2, index) => (
          <div key={index} className="song-preview-verse">
            <div className="fg-ac1 fs-6 mb-1">
              {verseLabel(song.lyrics[index] || [], verse2, index, numLabels)}
            </div>
            {song.lyrics[index] && song.lyrics[index].map((line, i) => (
              <div key={i} className="fg-l1 fs-6">{textCleanup(line)}</div>
            ))}
            {verse2.map((line, i) => (
              <div key={i} className="fg-l2 fs-6">{textCleanup(line)}</div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

export default SongPreview
